import styled from 'styled-components';

export const HeaderCodeForm = styled.form`
    flex: 0 1 240px;
    min-width: 0;
    -webkit-user-select: text;
    user-select: text;
`;

export const HeaderCodeField = styled.div`
    align-items: center;
    background: none;
    border: 2px solid rgba(255, 255, 255, 0.33);
    border-radius: 100px;
    box-sizing: border-box;
    display: flex;
    gap: 4px;
    height: 44px;
    min-width: 0;
    padding: 4px 4px 4px 16px;
    transition: border-color 0.2s ease-out;

    &:focus-within {
        border-color: rgba(255, 255, 255, 0.6);
    }
`;

export const HeaderCodeInput = styled.input`
    appearance: none;
    background: none;
    border: none;
    box-sizing: border-box;
    color: #FFFFFF;
    flex: 1 1 auto;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    height: 100%;
    min-width: 0;
    outline: none;
    padding: 0;

    &::placeholder {
        color: rgba(255, 255, 255, 0.45);
        font-weight: 600;
    }

    &:disabled {
        opacity: 0.6;
    }
`;

export const HeaderCodeSubmit = styled.button`
    align-items: center;
    background: rgba(255, 255, 255, 0.12);
    border: none;
    border-radius: 100px;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 600;
    height: 100%;
    justify-content: center;
    padding: 0 14px;

    &:hover:not(:disabled) {
        background: rgba(255, 255, 255, 0.2);
    }

    &:disabled {
        cursor: default;
        opacity: 0.45;
    }
`;
